import React from 'react';
import ComplianceItemsSection from '../../../sections/AdminDashboard/ComplianceItems/ComplianceItems';

const ComplianceItems = () => {
  return <ComplianceItemsSection />;
};

export default ComplianceItems;
